import { render } from "./LoginExtension.vue?vue&type=template&id=189c15e7"
import script from "./LoginExtension.vue?vue&type=script&lang=js"
export * from "./LoginExtension.vue?vue&type=script&lang=js"

import exportComponent from "/hpgdata/workspace/kumc_hospital_front_prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__